
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators",
      function () {
        return require("private-next-pages/creators.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators"])
      });
    }
  